const refreshLoginRequest = () => (state) => {
  return Object.assign({}, state, {
    isLoading: false,
    isRefreshing: true,
    error: null,
  })
}

export default refreshLoginRequest
